import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyD8UJP0rkVRK1JG1Yz49Kda68SedSvG0Uc",
  authDomain: "convive-a5305.firebaseapp.com",
  projectId: "convive-a5305",
  storageBucket: "convive-a5305.firebasestorage.app",
  messagingSenderId: "309010190352",
  appId: "1:309010190352:web:a475a2f4fca7e43f913a95",
  measurementId: "G-05F8YNW6SR"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app); 